var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFb = function SvgFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "fb_svg__Layer_1",
    fill: "currentColor",
    "data-name": "Layer 1",
    viewBox: "0 0 128 128"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fb_svg__cls-2{fill:#fff}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.72 63.52A59.06 59.06 0 1 0 46.27 120V69.15H34.45V52h11.82v-3.37q0-13 7.7-20.73t21.94-7.77a43.2 43.2 0 0 1 9.33 1 21.8 21.8 0 0 1 7.63 3.14L87 40.36a15.3 15.3 0 0 0-4.13-2 16 16 0 0 0-4.85-.72q-4.85 0-7.48 2.78c-1.76 1.86-2.64 4.63-2.64 8.34V52h19.7v17.15H68.5v53.19a59 59 0 0 0 54.22-58.82",
    className: "fb_svg__cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5 65.44v3.71h19.1v-17.1H67.94v3.84zM67.93 48.77c0-3.71.88-6.48 2.64-8.34s4.25-2.78 7.48-2.78a16 16 0 0 1 4.85.72 15.3 15.3 0 0 1 4.13 2l5.84-16.1a21.8 21.8 0 0 0-7.63-3.14 43.2 43.2 0 0 0-9.33-1q-14.25 0-21.91 7.77t-7.7 20.73V52h21.63ZM34.45 52.04h11.82v17.1H34.45zM46.27 69.15V120a59.1 59.1 0 0 0 17.39 2.61c1.63 0 3.24-.11 4.84-.24V69.15Z",
    className: "fb_svg__cls-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m68.5 65.44-.56-9.55v-3.84H46.27v17.1H68.5z",
    className: "fb_svg__cls-2"
  })));
};
export default SvgFb;